import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Projects from '../components/Projects';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import SeoHead from '../components/SeoHead';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-cream">
      <SeoHead
        title="Carol Mezher – Writer, Producer, Creative Consultant | Paris"
        description="Multidisciplinary Content Director & Creative Producer shaping projects from concept to audience across film, media, and live experiences."
        path="/"
      />
      <Header />
      <Hero />
      <About />
      {/* Services section is hidden on the homepage at mobile widths only.
          The standalone /services page (ServicesPage.jsx) and the Services
          link in the menu are unaffected. */}
      <div className="hidden md:block">
        <Services />
      </div>
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;